import React from 'react';
import TournamentContainer from './TournamentContainer';

const TournamentView = () => {
  return <TournamentContainer />;
};

export default TournamentView;
